import 'reflect-metadata';
const primitiveTypes = [Boolean, Number, String];
function alreadyObserved(target, key, type) {
    return target.constructor[observeType(type)].includes(key);
}
function observeType(type) {
    return primitiveTypes.includes(type) ? 'observedAttributes' : 'observedProperties';
}
function observe(target, key, type) {
    if (!alreadyObserved(target, key, type)) {
        target.constructor[observeType(type)].push(key);
    }
}
function getter(key, type) {
    return function () {
        switch (type) {
            case String:
                return this.getAttribute(key);
            case Number:
                if (this.hasAttribute(key)) {
                    return Number(this.getAttribute(key));
                }
                else {
                    return null;
                }
            case Boolean:
                return this.hasAttribute(key);
            default:
                return this[`_${key}`];
        }
    };
}
function setter(key, type) {
    return function (value) {
        if (value === null || value === undefined || value === false) {
            this.removeAttribute(key);
        }
        else {
            switch (type) {
                case String:
                    this.setAttribute(key, String(value));
                    break;
                case Number:
                    this.setAttribute(key, String(value));
                    break;
                case Boolean:
                    this.setAttribute(key, '');
                    break;
                default:
                    this[`_${key}`] = value;
            }
        }
        this.render();
    };
}
export function Property() {
    return function (target, key) {
        const type = Reflect.getMetadata('design:type', target, key);
        observe(target, key, type);
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: true,
            get: getter(key, type),
            set: setter(key, type),
        });
    };
}
//# sourceMappingURL=decorators.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nutmeg/seed/dist/decorators.js
// module id = ./node_modules/@nutmeg/seed/dist/decorators.js
// module chunks = 0 1